import React, {useEffect, useState} from 'react'
import Pal from './Pal'
import fetchSideBarResponse from '../sidebarRequests';
import { ColorRing } from 'react-loader-spinner';

function MotivationSeeker({onClose, isVisible}) {
  const [promptResponse, setPromptResponse] = useState("");
  const [displayQuestion, setDisplayQuestion]= useState(true);
  const [displayAnswer, setDisplayAnswer] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleGetInspiration = async() =>{

        setIsLoading(true);
        document.getElementById('main-sidebar-button').disabled = true;
        const response = await fetchSideBarResponse("inspire");
        if(response){
            setIsLoading(false);
            setPromptResponse(response.response);
            setDisplayQuestion(false);
            setDisplayAnswer(true);
        }
  }

  const promptResponseRenderer = () => {
        if(promptResponse != ""){
            return <div dangerouslySetInnerHTML={{ __html: promptResponse }} />;
        }
        return
  }

  const handleClose= ()=> {
    handleRetry();
    onClose();
  }

  const handleRetry = ()=>{
    setDisplayAnswer(false);
    setDisplayQuestion(true);
  }
  return (
    <div id = "pal-body"  style={{ display: isVisible ? 'flex' : 'none' }}>
        <Pal/>
        {displayQuestion && <div id ="sidebar-question-container">
            <div id='pal-question'>
                Inspiration is a click away!
            </div>
            {isLoading && <ColorRing
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="blocks-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="blocks-wrapper"
                                    colors={[
                                    "#e15b64",
                                    "#f47e60",
                                    "#f8b26a",
                                    "#abbd81",
                                    "#849b87",
                                    ]}
                                />}
            <button class="form-submit-button" onClick= {handleGetInspiration} id='main-sidebar-button'>Inspire</button>
            <button class="form-submit-button" onClick= {handleClose} id='sidebar-button'>Close</button>
        </div>}
        { displayAnswer &&
            <div id="promptResponse">
                {promptResponseRenderer()}
                <button class="form-submit-button" onClick= {handleClose} id='sidebar-button-close'>Close</button>
                <button class="form-submit-button" onClick= {handleRetry} id='sidebar-button-retry'>Try Again</button>
             </div>
        }
    </div>
  )
}

export default MotivationSeeker;